var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cpt-role-avatar",class:`${_vm.size} ${_vm.shape}`},[_c('div',{staticClass:"avatar-img-background",class:{'gradient': _vm.gradient}},[(_vm.img)?_c('ChatImg',{attrs:{"src":_vm.img,"lazy":!_vm.no_lazy,"animation":!_vm.no_lazy,"webp_quality":30,"thumbnail":_vm.thumbnail}}):_c('i',{staticClass:"iconfont",class:_vm.icon,style:({
        'color': _vm.color,
        'background-image': _vm.gradient_color
      })})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }